import React from 'react'
import styles from './MicrositeDnsVerifiedIcon.module.css'
import { CheckCircle2, Clock } from 'lucide-react'

/**
 * MicrositeDnsVerifiedIcon
 * Compact verified/pending indicator for domain DNS state.
 *
 * Usage:
 *   <MicrositeDnsVerifiedIcon verified={domain.dnsVerified} />
 */
const MicrositeDnsVerifiedIcon = ({ verified }) => (
    <span className={`${styles.wrap} ${verified ? styles.verified : styles.pending}`} title={verified ? 'DNS verified' : 'DNS verification pending'}>
        {verified ? <CheckCircle2 size={14} /> : <Clock size={14} />}
        {verified ? 'Verified' : 'Pending'}
    </span>
)

export default MicrositeDnsVerifiedIcon